/* eslint-disable @typescript-eslint/no-unused-expressions */

import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('aggregateEditor', [
  '$translate',
  '$timeout',
  function ($translate, $timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./aggregate-editor.html'),

      replace: true,

      controller: [
        '$scope',
        'ngrxStoreService',
        function ($scope, ngrxStoreService) {
          $scope.groupByValidity = true;
          $scope.aggregateValidity = true;

          $scope.onGroupingTypeChange = ({ grouping_type }) => {
            const component = { grouping_type };
            if (grouping_type === 'all') {
              component.grouped_fields = [];
            }
            ngrxStoreService.dispatch(updateComponent({ component }));
          };

          $scope.groupByCollectionSettings = {
            outsideSourceValidation: {
              unique: {
                validation: [],
                message: $translate.instant('aggregate-editor.form.errors.duplicate_fields'),
              },
            },
          };

          $scope.aggregateCollectionSettings = {
            outsideSourceValidation: {
              unique: {
                validation: [],
                message: $translate.instant('aggregate-editor.form.errors.duplicate_fields'),
              },
            },
          };

          $scope.onAggregatedRecordsChange = (records) => {
            $scope.component.aggregated_fields = records;
          };

          $scope.onAggregateValidityChange = (isValid) => {
            $scope.aggregateValidity = isValid;
          };

          $scope.onGroupedRecordsChange = (records) => {
            $scope.component.grouped_fields = records;
          };

          $scope.onGroupedValidityChange = (isValid) => {
            $scope.groupByValidity = isValid;
          };

          $scope.$watch(
            '[groupByValidity, aggregateValidity, component.grouping_type]',
            function () {
              const valid =
                !($scope.component.grouping_type === 'group_by' && !$scope.groupByValidity) && $scope.aggregateValidity;
              $scope.onValidityChange(valid);
            },
            true,
          );

          $scope.$watch(
            'component.grouped_fields',
            function (records) {
              $scope.aggregateCollectionSettings.outsideSourceValidation.unique.validation = _.pluck(
                records,
                'field_name',
              );
              $scope.aggregateCollectionSettings = { ...$scope.aggregateCollectionSettings };
            },
            true,
          );

          $scope.$watch(
            'component.aggregated_fields',
            function (records) {
              $scope.groupByCollectionSettings.outsideSourceValidation.unique.validation = _.pluck(records, 'alias');
              $scope.groupByCollectionSettings = { ...$scope.groupByCollectionSettings };
            },
            true,
          );

          $scope.$watch('component.grouping_type', function (currentGroupingType, lastGroupingType) {
            if (currentGroupingType === 'all') {
              $scope.aggregateCollectionSettings.outsideSourceValidation.unique.validation = [];
              $scope.aggregateCollectionSettings = { ...$scope.aggregateCollectionSettings };
            } else if (angular.isDefined(lastGroupingType) && lastGroupingType !== currentGroupingType) {
              $scope.aggregateCollectionSettings.outsideSourceValidation.unique.validation = _.pluck(
                $scope.groupByRecords,
                'field_name',
              );
              $scope.aggregateCollectionSettings = { ...$scope.aggregateCollectionSettings };
            }
          });
        },
      ],
    };
  },
]);
